import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import BackgroundImg from "../assets/images/aboutUsImg.png";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import './aboutUsPage.scss';
import Newslatter from "../components/newslatter/newsletter";

const theCoreBgImage = require('../assets/images/the-core.png');

const AboutUsPage = () => {

  return (<div className="main-layout-container ">
    <ImgBackground insideText={"About Us"} imgPath={BackgroundImg} />
    <div className="about-us-description-section">
      <span className="title">Cube Global, based in Saint Kitts and Nevis, is a provider of custom software development and IT consulting services, backed by a team of international IT experts. We focus on delivering tailored and platform-based solutions to midsized and large companies across a wide range of industries.</span>
      <div className="description-container">
        <span>Our core expertise lies in offering innovative software development, technology solutions, and corporate management consulting services specifically designed for small and medium-sized businesses. We also have extensive experience providing custom and platform-based solutions to midsized and large enterprises in industries such as healthcare, telecommunications, retail, and financial services. Additionally, we offer strategic guidance to startups, helping them navigate their journey to success.</span>
        <span>With a foundation built on scientific principles, Cube Global continually advances its expertise in critical areas, including Business Intelligence Platforms, Reconciliation Solutions, Accounting Software, CRM, data analysis, VoIP, and information security.</span>
        <span>Our partnerships with industry leaders in software and hardware provide our clients with access to cutting-edge knowledge and elite networks, equipping them to thrive in today’s competitive landscape.</span>
        </div>
    </div>
    {/* <div className="the-core-section">
      <div className="text-container">
        <span className="title">About Us</span>
        <span className="description">The core of our client operations is at our Saint Kitts and Nevis Office, but this is supplemented with a network of satellite offices spread globally, servicing customers in over 30 Countries.<br/><br/>Cube Global ent have been delivering software solutions for middle-market and enterprise customers across multiple target industries including:</span>
        <div className="list-container">
          <div className="list">
            <span className="item">Banking</span>
            <span className="item">Finance</span>
            <span className="item">Healthcare</span>
          </div>
          <div className="list">
            <span className="item">Retail</span>
            <span className="item">Telecom</span>
            <span className="item">Public Sector</span>
          </div>
        </div>
      </div>
      <img src={theCoreBgImage} alt="People working" />
    </div> */}
    {/* <TestimonialsTravala /> */}
    {/* <Newslatter/> */}
  </div>)
}

export default AboutUsPage;